/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/application.js":
/*!************************************!*\
  !*** ./src/scripts/application.js ***!
  \************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_application_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../styles/application.scss */ \"./src/styles/application.scss\");\n/* harmony import */ var _utils_animation_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils/animation.js */ \"./src/scripts/utils/animation.js\");\n\n\n\n//=====================================================================================================================\n\nconst removePreloader = () => {\n  document.body.classList.remove('loading');\n};\n\n//=====================================================================================================================\n\ndocument.addEventListener(\"DOMContentLoaded\", function () {\n  document.body.classList.add('fade-in');\n  document.querySelectorAll('.animated-block-left').forEach(block => {\n    _utils_animation_js__WEBPACK_IMPORTED_MODULE_1__.observer.observe(block);\n  });\n  document.querySelectorAll('.animated-block-right').forEach(block => {\n    _utils_animation_js__WEBPACK_IMPORTED_MODULE_1__.observer.observe(block);\n  });\n  document.querySelectorAll('.animated-block-bottom').forEach(block => {\n    _utils_animation_js__WEBPACK_IMPORTED_MODULE_1__.observerWithDelay.observe(block);\n  });\n});\n\n//# sourceURL=webpack://fabric_and_stitchers/./src/scripts/application.js?\n}");

/***/ }),

/***/ "./src/scripts/utils/animation.js":
/*!****************************************!*\
  !*** ./src/scripts/utils/animation.js ***!
  \****************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   observer: function() { return /* binding */ observer; },\n/* harmony export */   observerWithDelay: function() { return /* binding */ observerWithDelay; }\n/* harmony export */ });\nconst observer = new IntersectionObserver(entries => {\n  entries.forEach(entry => {\n    if (entry.isIntersecting) {\n      entry.target.classList.add('visible');\n      observer.unobserve(entry.target);\n    }\n  });\n}, {\n  threshold: 0.5\n});\nconst observerWithDelay = new IntersectionObserver(entries => {\n  entries.forEach(entry => {\n    if (entry.isIntersecting) {\n      const delay = entry.target.getAttribute('data-animated-block-bottom');\n      setTimeout(() => {\n        entry.target.classList.add('visible');\n        observer.unobserve(entry.target);\n      }, delay * 300);\n    }\n  });\n}, {\n  threshold: 0.5\n});\n\n//# sourceURL=webpack://fabric_and_stitchers/./src/scripts/utils/animation.js?\n}");

/***/ }),

/***/ "./src/styles/application.scss":
/*!*************************************!*\
  !*** ./src/styles/application.scss ***!
  \*************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://fabric_and_stitchers/./src/styles/application.scss?\n}");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/application.js");
/******/ 	
/******/ })()
;